import { render, staticRenderFns } from "./RInitialsIcon.vue?vue&type=template&id=872c6d62&scoped=true&"
import script from "./RInitialsIcon.vue?vue&type=script&lang=js&"
export * from "./RInitialsIcon.vue?vue&type=script&lang=js&"
import style0 from "./RInitialsIcon.vue?vue&type=style&index=0&id=872c6d62&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "872c6d62",
  null
  
)

export default component.exports